var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch, Model } from "vue-property-decorator";
import ImgLinkInput from './ImgLinkInput';
import { EShopLinkType } from '../../../../enum/EShopLinkType';
import draggable from 'vuedraggable';
var ImgUploaderList = (function (_super) {
    __extends(ImgUploaderList, _super);
    function ImgUploaderList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eShopLinkType = EShopLinkType;
        _this.innerFileList = [];
        return _this;
    }
    ImgUploaderList.prototype.fileListWatch = function () {
        this.innerFileList = this.fileList;
        if (this.$refs.upload) {
            var currentLength = this.innerFileList.length;
            var displayStatus = currentLength >= 5 ? "none" : "";
            this.$refs.upload.$children[1].$el.style.display = displayStatus;
        }
    };
    ImgUploaderList.prototype.addItem = function () {
        var defaultObj = {
            type: this.eShopLinkType.GOOD,
            file: {},
            relate_id_category: '',
            relate_name_category: '',
            relate_id_good: '',
            relate_name_good: ''
        };
        var imageList = JSON.parse(JSON.stringify(this.innerFileList));
        imageList.push(defaultObj);
        this.$emit("change", imageList);
    };
    ImgUploaderList.prototype.remove = function (index) {
        var imageList = JSON.parse(JSON.stringify(this.innerFileList));
        imageList.splice(index, 1);
        this.$emit("change", imageList);
    };
    ImgUploaderList.prototype.onEnd = function () {
        this.$emit('change', this.innerFileList);
    };
    __decorate([
        Prop({
            default: "/supplierapi/upload",
            type: String
        })
    ], ImgUploaderList.prototype, "action", void 0);
    __decorate([
        Prop({
            default: "",
            type: String
        })
    ], ImgUploaderList.prototype, "typeName", void 0);
    __decorate([
        Prop({
            default: 5,
            type: Number
        })
    ], ImgUploaderList.prototype, "limit", void 0);
    __decorate([
        Prop({
            default: 10,
            type: Number
        })
    ], ImgUploaderList.prototype, "maxSize", void 0);
    __decorate([
        Prop({
            default: "750px*260px",
            type: String
        })
    ], ImgUploaderList.prototype, "pixelTip", void 0);
    __decorate([
        Prop({
            default: false,
            type: Boolean
        })
    ], ImgUploaderList.prototype, "isSinglePic", void 0);
    __decorate([
        Prop({
            default: true,
            type: Boolean
        })
    ], ImgUploaderList.prototype, "isNeedGoods", void 0);
    __decorate([
        Model("change", {
            required: true,
            type: Array,
        })
    ], ImgUploaderList.prototype, "fileList", void 0);
    __decorate([
        Watch("fileList", { immediate: true, deep: true })
    ], ImgUploaderList.prototype, "fileListWatch", null);
    ImgUploaderList = __decorate([
        Component({
            components: {
                draggable: draggable,
                ImgLinkInput: ImgLinkInput
            }
        })
    ], ImgUploaderList);
    return ImgUploaderList;
}(Vue));
export default ImgUploaderList;
